import React, { useContext, useEffect, useRef, useState } from "react";
import { AttributeContext } from "../AttributeContext";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import { getConstraintsByAttributeID } from "api/Attributes";
import {toast} from 'react-toastify'


const ConstraintsItem = ({ label, value, col = 12 }) => {
  return (
    <div className="col-6">
      <div className="">
        {/* <Label message={value} fontSize={0.8} /> */}
        <li>
          <span className={"ms-2"}>
            {/* <strong>{value}: </strong> */}
            <Label message={`${label}:`} fontSize={0.8} />
          </span>
          &nbsp;
          <br />
          <span className={"ms-2"}>
            <Label
              message={`${value}`}
              fontSize={0.8}
              fontWeight="500"
              color="#A1A1A1"
            />
            {/* {`${value}`} */}
          </span>
        </li>
      </div>
    </div>
  );
};

const AttributeConstraintView = () => {
  const attributeContextDate = useContext(AttributeContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [collapse, setCollapse] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
  const attrId = useRef(null)


  const [attributeConstraintView, setAttributeConstraintView] = useState(null);

  useEffect(() => {
    setLoading({
      status: "",
      message: "",
    });
  }, [attributeContextDate.editingItem.id]);

  useEffect(() => {
    if (collapse) {
      fetchAttributes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapse]);

  async function fetchAttributes() {
    if(!collapse || attrId.current === attributeContextDate.editingItem.id) return 
    attrId.current = attributeContextDate.editingItem.id
    setLoading({status: "Loading", message: "Loading..."})
    getConstraintsByAttributeID(attributeContextDate.editingItem.id)
    .then((res) => {
      setAttributeConstraintView(res)
      setLoading({
        status: "Success",
        message: ""
      })
    })
    .catch(err => {
      setLoading({
        status: "Error",
        message: err.message
      })
      toast.error(err.message)
    })
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  return (
    <>
      <div className="accordion" id="accordionFlushConstraint">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseConstraint"
            aria-expanded="false"
            aria-controls="flush-collapseConstraint"
            style={Utils.borderStyle()}
          >
            <div>
              <Label
                message={`${enableEdit ? "Update " : ""} Attribute Constraints`}
              />
            </div>
          </div>

          <div
            id="flush-collapseConstraint"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingConstraint"
            data-bs-parent="#accordionFlushConstraint"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              {/* <LoadingSuccessErrorAlert loading={loading} /> */}

              { 
                loading.status === "Loading" && (
                  <div
                    className="alert alert-primary bg-white small p-2"
                    role="alert"
                  >
                    <span className="fas fa-circle-notch fa-spin" />
                    &nbsp;
                    <strong>{loading.message}</strong>
                  </div>
              )}

              { 
                loading.status === "Error" && (
                  <div
                    className="alert alert-danger small p-2"
                    role="alert"
                  >
                    <strong>{loading.message}</strong>
                  </div>
              )}

              {loading.status === "Success" && (
                    <div
                      className="p-3"
                      style={{ border: "1px solid #d6d8d9" }}
                    >
                      <div>
                        <ul className="list-unstyled">
                          {attributeConstraintView ? (
                            <div className="container overflow-hidden">
                              <div className="row gy-3">
                                <ConstraintsItem
                                  label="Validation"
                                  value={`${attributeConstraintView.validation}`}
                                />
                                <ConstraintsItem
                                  label="Allowed Chars"
                                  value={attributeConstraintView.allowed_chars}
                                />
                                <ConstraintsItem
                                  label="Attr id"
                                  value={attributeConstraintView.id}
                                />
                                <ConstraintsItem
                                  label="Allowed User Defined Values "
                                  value={
                                    attributeConstraintView.allowed_user_defined_values
                                  }
                                />
                                <ConstraintsItem
                                  label="Prohibited Chars"
                                  value={`${attributeConstraintView.prohibited_chars}`}
                                />
                                <ConstraintsItem
                                  label="Attr Inheritance"
                                  value={`${attributeConstraintView.attr_inheritance}`}
                                />
                                <ConstraintsItem
                                  label="Multi Select"
                                  value={`${attributeConstraintView.multiselect}`}
                                />

                                <ConstraintsItem
                                  label="Child Attr "
                                  value={`${attributeConstraintView.child_attr}`}
                                />

                                <ConstraintsItem
                                  label="Multiselect Number "
                                  value={
                                    attributeConstraintView.multiselect_number !==
                                    null
                                      ? attributeConstraintView.multiselect_number
                                      : ""
                                  }
                                />

                                <ConstraintsItem
                                  label="Datatype "
                                  value={attributeConstraintView.datatype}
                                />

                                <ConstraintsItem
                                  label="Multiselect Output Range "
                                  value={
                                    attributeConstraintView.multiselect_output_range
                                  }
                                />

                                <ConstraintsItem
                                  label="Validation Type "
                                  value={
                                    attributeConstraintView.validation_type
                                  }
                                />

                                {/* <ConstrainItem
                                  test="Allowed Chars "
                                  value={`${attributeConstraint.allowed_chars}`}
                                /> */}
                                {/* <ConstraintLabel
                                  value={`${attributeConstraint.validation}`}
                                /> */}

                                {/* <ConstraintsItem
                                  label="Multiselect Output Range "
                                  value={`${attributeConstraint.multiselect_output_range}`}
                                /> */}

                                <ConstraintsItem
                                  label="Validation Type Extra Criteria "
                                  value={
                                    attributeConstraintView.validation_type_extra_criteria
                                  }
                                />

                                <ConstraintsItem
                                  label="Special Formatting "
                                  value={
                                    attributeConstraintView.special_formatting
                                  }
                                />

                                <ConstraintsItem
                                  label="Extra Criteria Value 1 "
                                  value={
                                    attributeConstraintView.extra_criteria_value1
                                  }
                                />

                                <ConstraintsItem
                                  label="Validation Range "
                                  value={
                                    attributeConstraintView.validation_range
                                  }
                                />

                                <ConstraintsItem
                                  label="Extra Criteria Value 2 "
                                  value={`${attributeConstraintView.extra_criteria_value2}`}
                                />

                                <ConstraintsItem
                                  label="Validation Error Alert Style "
                                  value={
                                    attributeConstraintView.validation_error_alert_title
                                  }
                                />

                                <ConstraintsItem
                                  label="Validation Input Message "
                                  value={`${attributeConstraintView.validation_input_message}`}
                                />

                                <ConstraintsItem
                                  label="Multiselect Output Range "
                                  value={`${attributeConstraintView.multiselect_output_range}`}
                                />

                                <ConstraintsItem
                                  label="Validation Error Alert "
                                  value={`${attributeConstraintView.validation_error_alert}`}
                                />
                                <ConstraintsItem
                                  label="Validation Error Alert Body "
                                  value={`${attributeConstraintView.validation_error_alert_body}`}
                                />
                                <ConstraintsItem
                                  label="Validation Error Alert Title "
                                  value={`${attributeConstraintView.validation_error_alert_title}`}
                                />
                                <ConstraintsItem
                                  label="Validation Input Message Body "
                                  value={`${attributeConstraintView.validation_input_message_body}`}
                                />
                                <ConstraintsItem
                                  label="Validation Input Message Title "
                                  value={`${attributeConstraintView.validation_input_message_title}`}
                                />
                              </div>
                            </div>
                          ) : (
                            <div
                              className="alert alert-primary p-1"
                              role="alert"
                            >
                              No categories attributes constraints found
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttributeConstraintView;
